import Lottie from 'lottie-react'
import quickAnimation from '../../assets/animations/quick.json'

interface SpeedIconProps {
  className?: string
  size?: number
}

const SpeedIcon = ({ className = "w-12 h-12", size }: SpeedIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <Lottie
        animationData={quickAnimation}
        loop={true}
        autoplay={true}
        style={{ width: size || '100%', height: size || '100%' }}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid meet'
        }}
      />
    </div>
  )
}

export default SpeedIcon